import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const TailwindPagination = ({
  totalPages = 1,
  currentPage = 1,
  onClick,
  totalResults,
  pageLimit,
}) => {
  if (totalPages === 1) {
    return null;
  }
  const handlePaginationClick = pageNumber => {
    onClick(pageNumber);
  };

  const renderPaginationButtons = () => {
    const buttons = [];
    const visiblePageCount = 5; // Number of visible page numbers
    const startPage = Math.max(
      1,
      currentPage - Math.floor(visiblePageCount / 2)
    );
    const endPage = Math.min(totalPages, startPage + visiblePageCount - 1);

    // Add "First" button
    buttons.push(
      <button
        key="first"
        onClick={() => handlePaginationClick(1)}
        disabled={currentPage === 1}
        className="relative inline-flex items-center rounded-r-md px-4 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:text-brand focus:z-20 focus:outline-offset-0"
      >
        {"|<"}
      </button>
    );

    // Add "Previous" button
    buttons.push(
      <button
        key="prev"
        onClick={() => handlePaginationClick(currentPage - 1)}
        disabled={currentPage === 1}
        className="relative inline-flex items-center rounded-r-md px-4 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:text-brand focus:z-20 focus:outline-offset-0"
      >
        <FaChevronLeft />
      </button>
    );

    // Add ellipsis if necessary
    if (startPage > 1) {
      buttons.push(
        <span className={"px-4"} key="ellipsisStart">
          {"..."}
        </span>
      );
    }

    // Add page numbers
    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePaginationClick(i)}
          disabled={currentPage === i}
          className={
            `relative hidden items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:text-brand focus:z-20 focus:outline-offset-0 md:inline-flex ${currentPage === i ? 'bg-brand text-white' : ''}`
          }
        >
          {i}
        </button>
      );
    }

    // Add ellipsis if necessary
    if (endPage < totalPages) {
      buttons.push(
        <span className={"px-4"} key="ellipsisEnd">
          {"..."}
        </span>
      );
    }

    // Add "Next" button
    buttons.push(
      <button
        className={"px-4 hover:text-brand "}
        key="next"
        onClick={() => handlePaginationClick(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <FaChevronRight />
      </button>
    );

    // Add "Last" button
    buttons.push(
      <button
        className={"px-4 hover:text-brand "}
        key="last"
        onClick={() => handlePaginationClick(totalPages)}
        disabled={currentPage === totalPages}
      >
        {">|"}
      </button>
    );

    return buttons;
  };

  const startResult = (currentPage - 1) * pageLimit + 1;
  const endResult = Math.min(currentPage * pageLimit, totalResults);

  return (
    <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-gray-700">
            Showing <span className="font-medium">{startResult}</span> to{" "}
            <span className="font-medium">{endResult}</span> of{" "}
            <span className="font-medium">{totalResults}</span> results
          </p>
        </div>
        <nav
          className="isolate inline-flex -space-x-px rounded-md shadow-sm"
          aria-label="Pagination"
        >
          {renderPaginationButtons()}
        </nav>
      </div>
    </div>
  );
};

export default TailwindPagination;
